import React from 'react';
import LoginForm from '../LoginForm/LoginForm';
import { useHistory, useLocation } from 'react-router-dom';
import CompanyNav from '../Nav/CompanyNav';

import Button from '@mui/material/Button';


function LoginPage() {
  const history = useHistory();
  const resetPassword = () => {
    history.push('/reset-password')
  }

  return (
    <div>
      <CompanyNav />
      <LoginForm />
      <center>
        <Button onClick={resetPassword}>Forgot Password?</Button>
      </center>
    </div>
  );
}

export default LoginPage;
